export interface KlingOptions {
  duration: number;
  aspectRatio: string;
}

export const defaultKlingOptions: KlingOptions = {
  duration: 5,
  aspectRatio: '9:16',
};
